import { Box, FormControlLabel, Grid, Switch } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useState } from 'react';
import { INaturalPerson } from '../../../Interfaces/INaturalPerson';
import { arrayIncludes } from '../../public/Dialog/generic/utilities';
import { AcademicTitleField } from './fields/AcademicTitle/AcademicTitleField';
import { BirthdateField } from './fields/Birthdate/BirthdateField';
import { BirthplaceField } from './fields/Birthplace/BirthplaceField';
import { CountryField } from './fields/Country/CountryField';
import { DateOfDeathField } from './fields/DateOfDeath/DateOfDeathField';
import { FirstNameField } from './fields/FirstName/FirstNameField';
import { GenderField } from './fields/Gender/GenderField';
import { LastNameField } from './fields/LastName/LastNameField';
import { PlaceOfDeathField } from './fields/PlaceOfDeath/PlaceOfDeathField';

export type DeathOptions = {
  deathInfoMode?: 'none' | 'toggle' | 'always';
  requireDate?: boolean;
};

type IProps = {
  deathOptions?: DeathOptions;
};

const isDeathInfosEnabled = (deathOptions: DeathOptions) =>
  arrayIncludes(['toggle', 'always'], deathOptions.deathInfoMode);

export const NaturalPersonForm = ({
  deathOptions = { deathInfoMode: 'none', requireDate: false },
}: IProps) => {
  const [showDeathInfos, setShowDeathInfos] = useState(
    arrayIncludes(['toggle', 'always'], deathOptions.deathInfoMode) || false
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de'>
      <Grid item xs={3}>
        <GenderField<INaturalPerson> name='idGender' />
      </Grid>
      <Grid item xs={3}>
        <AcademicTitleField<INaturalPerson> name='idAcademicTitle' />
      </Grid>
      <Grid item xs={3}>
        <FirstNameField<INaturalPerson> name='FirstName' />
      </Grid>
      <Grid item xs={3}>
        <LastNameField<INaturalPerson> name='LastName' />
      </Grid>

      <Grid item xs={12}>
        <Box sx={{ mt: 0.5 }} />
      </Grid>

      <Grid item xs={4}>
        <BirthdateField<INaturalPerson> name='Birthdate' />
      </Grid>

      <Grid item xs={4}>
        <BirthplaceField<INaturalPerson> name='Birthplace' />
      </Grid>
      <Grid item xs={4}>
        <CountryField<INaturalPerson> name='idCountry' />
      </Grid>

      {isDeathInfosEnabled(deathOptions) && (
        <>
          {deathOptions.deathInfoMode === 'toggle' && (
            <Grid item xs={12}>
              <Box sx={{ mt: 0.5 }} />
              <FormControlLabel
                control={
                  <Switch
                    value={showDeathInfos}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setShowDeathInfos(event.target.checked);
                    }}
                  />
                }
                label='Verstorben'
              />
            </Grid>
          )}
          {showDeathInfos && (
            <>
              <Grid item xs={6}>
                <DateOfDeathField<INaturalPerson>
                  name='DateOfDeath'
                  required={deathOptions.requireDate}
                />
              </Grid>
              <Grid item xs={6}>
                <PlaceOfDeathField<INaturalPerson> name='PlaceOfDeath' />
              </Grid>
            </>
          )}
        </>
      )}
    </LocalizationProvider>
  );
};
